<p-card color="warn" [ngClass]="{'borderless-panel' : item.hide_border }">
    <ng-template pTemplate="title">
        <div class="card-title-header" *ngIf='item.heading' [ngClass]="{ 'hidden-panel-title' : item.hide_title }">{{item.translation_key||item.heading| translation|translationFromString | transformText :item?.text_transform}}</div>
    </ng-template>
    <div class="card-body">
        <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="info" *ngFor="let it of item.content" [item]="it" [arr]="item.content" [data]="data" (deleteDataEvent)="delete($event)" (openViewEvent)="openView($event)" (moveHandler)="openMove()" (openLinkEvent)="openLink($event)"></app-rendered>
    </div>
    <ng-template pTemplate="footer">
        <div class="card-footer" *ngIf='item.footer'>{{item.footer}}</div>
    </ng-template>
</p-card>
